import React from 'react';

const IntersectionSymbol = () => {
	return (
		<>
			<div className="intersection-symbol">&#8898;</div>
		</>
	);
};

export default IntersectionSymbol;
